export default __webpack_public_path__ + "static/media/6.a96eca09.png";